import * as React from "react";
import {
  Button,
  Flex,
  Image,
  Text,
  Card,
  Divider,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "../../ui-components/utils";

export default function DoctorDetailsCard(props) {
  const { overrides, ...rest } = props;
  return (
    <Card>
      <Flex
        direction="column"
        padding="6px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "DoctorCard")}
        {...rest}
      >
        <Flex direction={"row"} justifyContent="flex-end" alignItems="center">
          <Button
            variation="link"
            size="small"
            {...getOverrideProps(overrides, "EncountersAdd")}
            children="Add Encounter"
          />
          <Button
            variation="link"
            size="small"
            {...getOverrideProps(overrides, "AppointmentAdd")}
            children="Add Appointment"
          />
        </Flex>
        <Divider size="small" />
        <Flex
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          {...getOverrideProps(overrides, "Body")}
        >
          <Flex
            gap="3px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            grow="1"
            shrink="1"
            basis="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Container")}
          >
            <Text
              fontSize="15px"
              fontWeight="700"
              lineHeight="24px"
              direction="column"
              children="Provider Name"
              {...getOverrideProps(overrides, "DoctorNameLabel")}
            ></Text>
            <Text
              fontSize="15px"
              fontWeight="400"
              lineHeight="24px"
              direction="column"
              children="Provider Specialty"
              {...getOverrideProps(overrides, "Specialty")}
            ></Text>
            <Text
              fontSize="15px"
              fontWeight="400"
              lineHeight="24px"
              direction="column"
              children="Provider Secondary-Specialty"
              {...getOverrideProps(overrides, "SecondarySpecialty")}
            ></Text>
            <Text
              fontSize="15px"
              fontWeight="400"
              lineHeight="24px"
              direction="column"
              children="Added At"
              {...getOverrideProps(overrides, "AddedDate")}
            ></Text>
            <Text
              fontSize="15px"
              fontWeight="400"
              lineHeight="24px"
              direction="column"
              children="Last Seen"
              {...getOverrideProps(overrides, "LastSeenDate")}
            ></Text>
            <Text
              fontSize="15px"
              fontWeight="400"
              lineHeight="24px"
              direction="column"
              children="Encounters"
              {...getOverrideProps(overrides, "TotalEncounters")}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          alignSelf="stretch"
          {...getOverrideProps(overrides, "Footer")}
        >
          <Button
            size="small"
            variation="primary"
            children="Primary Provider"
            {...getOverrideProps(overrides, "PrimaryCareProviderButton")}
          ></Button>
          <Button
            variation="primary"
            size="small"
            {...getOverrideProps(overrides, "ViewButton")}
            children="View"
          ></Button>
          <Button
            variation="primary"
            size="small"
            {...getOverrideProps(overrides, "EditButton")}
          >
            Edit
          </Button>
          <Button
            variation="destructive"
            size="small"
            {...getOverrideProps(overrides, "DeleteButton")}
          >
            Delete
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
}
